import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IEmptyProps {
  copy?: string;
}
export const Empty: React.FC<IEmptyProps> = ({ copy }) => {
  const { t: translate } = useTranslation("common");
  return (
    <>
      <img
        alt={translate("states.alt_text.empty_inbox")}
        src="/images/empty_inbox.svg"
        style={{ width: "50%", maxWidth: 300 }}
      />
      <Box sx={{ mt: 2 }}>
        <Typography variant="body1">
          {copy || translate("states.messages.nothing_to_show")}
        </Typography>
      </Box>
    </>
  );
};
